var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaticText",domProps:{"innerHTML":_vm._s(_vm.staticText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }